import {
  Avatar,
  Flex,
  Menu,
  Overlay,
  Text,
  useMantineTheme,
} from "@mantine/core";
import { useDisclosure, useMediaQuery } from "@mantine/hooks";
import {
  ArrowDown2,
  DollarSquare,
  // KeySquare,
  LoginCurve,
  Profile,
  Setting3,
} from "iconsax-react";
import { useAuth } from "../../context/auth";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import MenuLanguage from "./MenuLanguage";
import { client_selected } from "../../client";
import { useTranslation } from "react-i18next";

const MenuUser = () => {
  const theme = useMantineTheme();
  const [opened, { open, close }] = useDisclosure(false);
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const isLargerThan991 = useMediaQuery("(min-width: 991px)");
  const { t } = useTranslation();

  const handleRedirect = useCallback(
    (path: string) => {
      close();
      navigate(path);
    },
    // eslint-disable-next-line
    [navigate]
  );
  const clientName = client_selected.name;
  const isEmpiricus = clientName === "Empiricus";
  const isUnderblock = clientName === "Underblock";
  const isGenial = clientName === "Genial";

  return (
    <>
      {opened && (
        <Overlay onClick={() => close()} opacity={0.25} color="#000" />
      )}
      <Menu
        shadow="md"
        width={280}
        zIndex={opened ? 300 : "unset"}
        offset={16}
        position="bottom-end"
        onOpen={open}
        onClose={close}
        closeOnItemClick={false}
        opened={opened}
        transitionProps={{
          transition: "scale-y",
          duration: 300,
          keepMounted: opened,
        }}
        styles={{
          dropdown: {
            width: 280,
            bg: theme.colors.other[0],
            borderRadius: "8px",
            boxShadow: "0px 1px 4px rgba(0, 0, 0, 0.25)",
            padding: "12px !important",
            gap: "8px !important",
          },
          item: {
            transition: "0.5s",
            padding: "8px",
            margin: "4px 0",
          },
          itemIcon: {
            marginRight: "16px",
          },
        }}
      >
        <Menu.Target>
          <Flex
            w={{ base: 76, 630: 280, 991: 92, 1400: 280 }}
            h={{ base: 48, 991: 56 }}
            align="center"
            justify="center"
            style={{
              position: "relative",
              content: "''",
              zIndex: "200",
            }}
          >
            <Flex
              w={{
                base: opened ? 280 : 76,
                630: opened ? 280 : 280,
                991: opened ? 280 : 92,
                1400: 280,
              }}
              h={{
                base: 48,
                991: 56,
                1600: 56,
              }}
              p={{ base: 8, 630: "8px 12px" }}
              bg={theme.colors.other[0]}
              gap={{ base: 8, 630: 12 }}
              direction="column"
              align="center"
              style={{
                overflow: "hidden",
                position: "absolute",
                top: 0,
                right: 0,
                borderRadius: "8px",
                transition: "all 0.3s linear",
              }}
            >
              <Flex
                gap={{
                  base: opened ? 8 : 4,
                  630: 8,
                  991: opened ? 12 : 4,
                  1400: 12,
                }}
                align="center"
                justify="space-between"
                w="fit-content"
                style={{
                  transition: "width 0.3s linear, height 0.3s linear",
                }}
              >
                <Avatar
                  component="span"
                  variant="outline"
                  size={isLargerThan991 ? 40 : 32}
                  color="basic.2"
                  radius={8}
                  src={"props.avatar"}
                  alt="Nome do parceiro"
                  styles={{
                    root: {
                      background: theme.colors.primary[1],
                      transition: "all 0.5s linear, width 0.5s linear",
                    },
                  }}
                >
                  <Profile color={theme.colors.basic[0]} />
                </Avatar>
                <Flex
                  w={{
                    base: opened ? 184 : 0,
                    630: 184,
                    991: opened ? 168 : 0,
                    1400: 168,
                  }}
                  h={{ base: 32, 991: 40 }}
                  direction="column"
                  pos="relative"
                  justify="center"
                  style={{
                    transition: "width 0.3s linear",
                  }}
                >
                  <Text
                    lh={{ base: "22px", 991: "25px" }}
                    fz={{ base: "14px", 991: "16px" }}
                    fw={600}
                    truncate
                  >
                    {user.name}
                  </Text>
                </Flex>
                <ArrowDown2
                  size={24}
                  color={theme.colors.basic[5]}
                  style={{
                    transform: opened ? "rotatex(180deg)" : "unset",
                    transition: "0.5s",
                  }}
                />
              </Flex>
            </Flex>
          </Flex>
        </Menu.Target>
        <Menu.Dropdown>
          {isGenial ? null : (
            <Menu.Item
              icon={<Setting3 size={28} color={theme.colors.basic[5]} />}
              onClick={() => handleRedirect("/meu-perfil/configuracoes")}
            >
              {t("global.routes_names.my_profile_config")}
            </Menu.Item>
          )}

          {isEmpiricus || isUnderblock || isGenial ? null : (
            <Menu.Item
              icon={<DollarSquare size={28} color={theme.colors.basic[5]} />}
              onClick={() => handleRedirect("/meu-perfil/financeiro")}
            >
              {t("global.routes_names.my_profile_financy")}
            </Menu.Item>
          )}

          {/* {isLargerThan991 ? null : (
            <Menu.Item
              icon={<KeySquare size={28} color={theme.colors.basic[5]} />}
              onClick={() => handleRedirect("/meu-perfil/senha")}
            >
             {t("global.routes_names.my_profile_password")}
            </Menu.Item>
          )} */}

          <MenuLanguage close={close} />

          <Menu.Divider />

          <Menu.Item
            color="red"
            onClick={logout}
            icon={<LoginCurve size={28} color={theme.colors.alerts[0]} />}
          >
            {t("global.navbar.menu_user.logout")}
          </Menu.Item>
        </Menu.Dropdown>
      </Menu>
    </>
  );
};

export default MenuUser;
